export default __webpack_public_path__ + "static/media/admin_logo.7f4ae3f8.svg";